export default "__VITE_ASSET__DLNhjx1f__"